export const getSagasMsgs = (state) => state.main.locale.sagasMsgs
